import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"max-width":"820px"}
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "pill" }
const _hoisted_4 = {
  key: 0,
  class: "item-card"
}
const _hoisted_5 = {
  key: 1,
  class: "grid",
  style: {"gap":"16px"}
}
const _hoisted_6 = { class: "item-card" }
const _hoisted_7 = { class: "item-title" }
const _hoisted_8 = { class: "item-meta" }
const _hoisted_9 = { class: "item-meta" }
const _hoisted_10 = {
  key: 0,
  class: "item-card"
}
const _hoisted_11 = { class: "item-meta" }
const _hoisted_12 = { class: "item-meta" }
const _hoisted_13 = {
  key: 1,
  class: "item-card"
}
const _hoisted_14 = { class: "item-meta" }
const _hoisted_15 = {
  key: 0,
  class: "image-grid",
  style: {"margin-top":"8px"}
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "item-meta"
}
const _hoisted_18 = {
  key: 2,
  class: "item-card"
}
const _hoisted_19 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page", { embedded: _ctx.embedded }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "title" }, "Documento de seguranca"),
          _createElementVNode("p", { class: "subtitle" }, "Visualizacao detalhada do formulario.")
        ], -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.submission?.title || 'Seguranca'), 1)
      ]),
      (!_ctx.submission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("h3", { class: "item-title" }, "Documento nao encontrado", -1),
            _createElementVNode("p", { class: "item-meta" }, "Volte e selecione outro item.", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.submission.title) + " - " + _toDisplayString(_ctx.submission.attraction), 1),
              _createElementVNode("div", _hoisted_8, "Data: " + _toDisplayString(_ctx.formatReportDate(_ctx.submission.reportDate)), 1),
              _createElementVNode("div", _hoisted_9, "Autor: " + _toDisplayString(_ctx.submission.author.name), 1)
            ]),
            (_ctx.isDialogo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "item-title" }, "Tema do dialogo", -1)),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.dialogTheme || 'Nao informado'), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("div", {
                    class: "item-title",
                    style: {"margin-top":"12px"}
                  }, "Participantes", -1)),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.participantsText), 1)
                ]))
              : (_ctx.isOcorrido)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "item-title" }, "Descricao do ocorrido", -1)),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.occurrenceText || 'Nao informado'), 1),
                    _cache[7] || (_cache[7] = _createElementVNode("div", {
                      class: "item-title",
                      style: {"margin-top":"12px"}
                    }, "Imagens", -1)),
                    (_ctx.occurrenceImages.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.occurrenceImages, (img, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `occ-img-${index}`,
                              class: "image-preview"
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.resolveUrl(img),
                                alt: "preview"
                              }, null, 8, _hoisted_16)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, "Sem imagens"))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("div", { class: "item-title" }, "Permissao de trabalho critico", -1),
                    _createElementVNode("div", { class: "item-meta" }, "Documento registrado, sem campos adicionais neste visualizador.", -1)
                  ]))])),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
              }, "Voltar"),
              _createElementVNode("button", {
                class: "btn btn-secondary",
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.edit && _ctx.edit(...args)))
              }, "Editar")
            ])
          ]))
    ])
  ], 2))
}